import { useLayoutEffect, useRef } from 'react';
import { ReactComponent as ErsteLogo } from '../../../assets/svg/loader/erste-logo-loader.svg';
import { featureFlagUtils } from '../../utils/FeatureFlagUtils';
import classes from './FullScreenLoader.module.scss';

const ErsteLoader = () => {
  const logoRef = useRef<SVGSVGElement | null>(null);
  useLayoutEffect(() => {
    if (logoRef.current) {
      const interval = setInterval(() => {
        if (logoRef.current!.classList.contains('active')) {
          logoRef.current!.classList.remove('active');
        } else {
          logoRef.current!.classList.add('active');
        }
      }, 1200);
      return () => {
        clearInterval(interval);
      };
    }
    return () => {};
  }, []);

  return (
    <div className="erste-loader-wrapper">
      <ErsteLogo ref={logoRef} />
    </div>
  );
};

export const FullScreenLoader = () => {
  if (featureFlagUtils.isErsteLoader) {
    return <ErsteLoader />;
  }

  return (
    <div className={classes.fullscreenLoader}>
      <span></span>
      <span></span>
    </div>
  );
};
